import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonItem,
  IonList,
  IonButtons,
  IonButton,
  IonGrid,
  IonCol,
  IonRow,
  IonLabel,
  IonBackButton,
  IonImg,
  IonModal,
  IonSlides,
  IonSlide,
  withIonLifeCycle,
  isPlatform,
  IonPopover,
  IonFooter,
} from "@ionic/react";

import { RouteComponentProps, withRouter } from "react-router";
import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef } from "react-zoom-pan-pinch";

import { TextToSpeech, TTSOptions } from "@capacitor-community/text-to-speech";

import { format } from "date-fns";

// CSS
import "./EssentialsPage.css";
import "../../Shared.css";
import "../../../App.css";

// Images
import buttonClose from "../../assets/Button_Close@3x.png";
import iconAccessibility from "../../assets/Button_Accessibility@3x.png";
import iconBookmarkActive from "../../assets/Button_Bookmark_2Active@3x.png";
import iconBookmarkInactive from "../../assets/Button_Bookmark_1Inactive@3x.png";
import iconPlayWhite from "../../assets/Button_Audio_Play_White@3x.png";
import iconStop from "../../assets/Button_Audio_Stop@3x.png";
import disclosureLeft from "../../assets/Button_Disclosure_Left_Blue@3x.png";
import disclosureRight from "../../assets/Button_Disclosure_Right_Blue@3x.png";

// Controllers
import {
  IScreenProps,
  IUser,
  IGuideline,
  IAlgorithm,
  IGuidelineSummary,
  IClinicalNotice,
  IEssentialSection,
} from "../../Interfaces";
import AppController from "../../../controllers/AppController";
import DataController from "../../controllers/DataController";
import RemoteDataController from "../../controllers/RemoteDataController";

// Components
import _ from "lodash";
import FontPopover from "../../components/FontPopover";
import ImageViewerModal from "../../components/ImageViewerModal";

type Props = RouteComponentProps<{ id: string; tab: string }> & { screenProps: IScreenProps; features: string[] };
type State = {
  selectedID: string;
  currentIndex: number;
  imageModalVisible: boolean;
  fontModalVisible: boolean;
  contentsModalVisible: boolean;
  fontModalEvent: any;
  imageSrc: any;
  remainingTextToSpeechText: string;
};

class EssentialsPage extends Component<Props, State> {
  private imageModalZoom: React.RefObject<ReactZoomPanPinchRef>;
  private ionContent: React.RefObject<HTMLIonContentElement>;

  constructor(props: Props) {
    super(props);

    this.imageModalZoom = React.createRef();
    this.ionContent = React.createRef();

    let selectedIDString = "";
    if (props.match.url != null) {
      selectedIDString = props.match.url.substr(props.match.url.lastIndexOf("/") + 1);
    }
    if (selectedIDString == null) {
      selectedIDString = props.match.url.substr(props.match.url.lastIndexOf("/") + 1);
    }

    this.state = {
      selectedID: selectedIDString,
      currentIndex: 0,
      imageModalVisible: false,
      fontModalVisible: false,
      contentsModalVisible: false,
      fontModalEvent: null,
      imageSrc: "",
      remainingTextToSpeechText: "",
    };
  }

  async componentDidMount() {
    document.addEventListener("click", this.handleClickEvent);

    // try {
    //   let essentialSection = this.props.screenProps.essentialSections.find((essentialSection) => essentialSection.id === this.state.selectedID);
    //   if (essentialSection != null) {
    //     this.logUsage(essentialSection);
    //   }
    // } catch (error) {

    // }
  }

  ionViewDidEnter() {
    let selectedIDString = "";
    if (this.props.match.url != null) {
      selectedIDString = this.props.match.url.substr(this.props.match.url.lastIndexOf("/") + 1);
    }

    if (selectedIDString !== this.state.selectedID) {
      for (
        let essentialSectionIndex = 0;
        essentialSectionIndex < this.props.screenProps.essentialSections.length;
        essentialSectionIndex++
      ) {
        let essentialSection = this.props.screenProps.essentialSections[essentialSectionIndex];

        if (essentialSection.id === selectedIDString) {
          this.goToSlide(essentialSectionIndex, "");
        }
      }
    }
  }

  ionViewWillLeave() {
    // back.remove();
    this.stopReading();
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickEvent);
  }

  logUsage(essentialSection: IEssentialSection) {
    try {
      if (this.props.screenProps.user != null) {
        let sectionNumber = "1";
        if (essentialSection.Chapter.includes("Chapter")) {
          sectionNumber = essentialSection.Section.split(" ")[0];
        }

        let essential = {
          chapter: essentialSection.Chapter,
          sectionNumber: sectionNumber,
        };
        RemoteDataController.logUsage(
          null,
          null,
          null,
          null,
          essential,
          false,
          "",
          this.props.screenProps.user,
          this.props.screenProps.app
        );
      }
    } catch (error) {}
  }

  handleClickEvent = (event: any) => {
    if (
      event.srcElement.localName === "link" ||
      event.srcElement.localName === "a" ||
      event.srcElement.className.includes("subSectionRow")
    ) {
      console.log(true, event.srcElement);
      if (this.props.match.url === event.currentTarget.location.pathname) {
        console.log(event.srcElement);

        try {
          let url: string = "";
          if (event.srcElement.className.includes("subSectionRow")) {
            url = "#" + event.srcElement.id;
          } else {
            url = event.srcElement.href.substring(event.srcElement.href.lastIndexOf("/") + 1);
          }

          if (url.startsWith("#")) {
            url = url.substring(1);

            let essentialSections = this.props.screenProps.essentialSections;

            for (
              let essentialSectionIndex = 0;
              essentialSectionIndex < essentialSections.length;
              essentialSectionIndex++
            ) {
              let essentialSection = essentialSections[essentialSectionIndex];

              if (essentialSection.HtmlData.includes(`id="${url}"`)) {
                this.goToSlide(essentialSectionIndex, url);
                break;
              }
            }
          } else {
            window.open(event.srcElement.href, "_blank");
            let link = document.createElement("a");
            link.setAttribute("href", event.srcElement.href);
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "noopener");
            link.click();
          }
        } catch (error) {}

        event.preventDefault();
        event.stopPropagation();
        this.closeContents();
      }
    }

    if (event.srcElement.localName === "img" && event.srcElement.className.includes("img11")) {
      console.log(event);
      // if (event.srcElement.className === "noticeImage" ||
      // event.srcElement.className === "noticeImage noticeImageMobile") {
      if (this.props.match.url === event.currentTarget.location.pathname) {
        console.log(event);
        RemoteDataController.logEvent("image_modal_clicked", {
          from: "essentials",
          // essentialsID: this.state.ess.ID,
        });
        this.toggleImageModal(true, event.srcElement);
      }
      // }
    }
  };

  handleBackEvent = (event: any) => {
    if (this.state.imageModalVisible) {
      this.setState({
        imageModalVisible: false,
      });
    } else if (this.state.fontModalVisible) {
      this.setState({
        fontModalVisible: false,
      });
    } else {
      // console.log(event);
    }
  };

  scrollToTop() {
    try {
      if (this.ionContent && this.ionContent.current) {
        this.ionContent.current.scrollToPoint(0, 0);
      }
    } catch (error) {}
  }

  async slideDidChange() {
    try {
      var slider: any = document.getElementById("essSlider");
      let index = await slider.getActiveIndex();

      this.setState({ currentIndex: index });

      let test = "";

      let essentialSection = this.props.screenProps.essentialSections[index];
      if (essentialSection != null) {
        this.logUsage(essentialSection);

        try {
          RemoteDataController.logEvent("essentials_section_viewed", { name: essentialSection.Name });
        } catch (error) {}
      }
    } catch (error) {}
  }

  goToPreviousSlide() {
    var slider: any = document.getElementById("essSlider");
    if (slider) {
      slider.slidePrev();
    }
  }

  goToNextSlide() {
    var slider: any = document.getElementById("essSlider");
    if (slider) {
      slider.slideNext();
    }
  }

  async goToSlide(index: number, id: string) {
    var slider: any = document.getElementById("essSlider");
    slider.slideTo(index);

    setTimeout(() => {
      var elementToScrollTo = document.getElementById(id);
      if (elementToScrollTo != null) {
        elementToScrollTo.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    }, 500);

    let test = "";
  }

  openContents() {
    this.setState({ contentsModalVisible: true });

    try {
      RemoteDataController.logEvent("essentials_contents_opened", {});
    } catch (error) {}
  }

  closeContents() {
    this.setState({ contentsModalVisible: false });
  }

  bookmarkButtonPressed() {
    try {
      let essentialSection = this.props.screenProps.essentialSections[this.state.currentIndex];
      this.props.screenProps.saveBookmark(essentialSection.id, null, null, null, "essentials");
    } catch (error) {
      console.log(error);
    }
  }

  isBookmarked() {
    try {
      let essentialSection = this.props.screenProps.essentialSections[this.state.currentIndex];
      let bookmark = _.find(this.props.screenProps.bookmarks, { GLID: essentialSection.id, type: "essentials" });
      return bookmark != null;
    } catch (error) {
      console.log(error);
    }

    return false;
  }

  toggleFontModal(value: boolean, event: any) {
    this.setState({
      fontModalVisible: value,
      fontModalEvent: event,
    });
    if (value === true) {
      RemoteDataController.logEvent("accessability_popover_opened", {
        from: "essentials",
      });
    }
  }

  toggleImageModal(value: boolean, srcElement?: any) {
    this.props.screenProps.showStatusBar(value, "#008477");

    if (srcElement) {
      let html = srcElement.outerHTML
        .replace('class="algorithmImage"', "")
        .replace('class="algorithmImage algorithmImageMobile"', "");

      this.setState({
        imageSrc: html,
        imageModalVisible: value,
      });
    } else {
      this.setState({
        imageModalVisible: value,
      });
    }
  }

  fontSize(size: number) {
    return `${size + this.props.screenProps.fontSizeChange}px`;
  }

  async readEssentialSection() {
    try {
      await this.stopReading();
      await DataController.waitForMilliseconds(500);

      let content: HTMLElement | null = null;

      let slideElementID = "essentials-" + this.state.currentIndex;

      content = document.getElementById("essentials-" + this.state.currentIndex);

      let text: string = "";

      if (content != null && content.innerText != null) {
        text = content.innerText;
        text = text.replace(/\n/g, ". ");
        text = text.replace(/\.\./g, ".");
        text = text.replace(/Play section/g, "");
        if (text.startsWith(". ")) {
          text = text.slice(2); // remove leading period space
        }

        let supportedLanguages = await TextToSpeech.getSupportedLanguages();

        if (supportedLanguages.languages.length > 0) {
          let remainingText = text + "";
          await this.setStateAsync({ remainingTextToSpeechText: remainingText });

          while (this.state.remainingTextToSpeechText.length > 0) {
            let text = this.state.remainingTextToSpeechText.substring(0, 3000);

            remainingText = this.state.remainingTextToSpeechText.substring(3000);

            await this.setStateAsync({ remainingTextToSpeechText: remainingText });

            let speechSpeed = DataController.convertTextToSpeechSpeed(this.props.screenProps.textToSpeechSpeed);

            let textToSpeechProperties: TTSOptions = {
              text: text,
              rate: speechSpeed,
              pitch: 1.0,
              volume: 1.0,
              category: "playback",
            };

            if (supportedLanguages.languages.includes("en-GB")) {
              textToSpeechProperties.lang = "en-GB";
            }

            await TextToSpeech.speak(textToSpeechProperties);

            try {
              RemoteDataController.logEvent("text_spoken", {
                from: "essentials",
              });
            } catch (error) {}
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async stopReading() {
    await this.setStateAsync({ remainingTextToSpeechText: "" });
    await TextToSpeech.stop();
  }

  setStateAsync(state: any) {
    return new Promise((resolve: any) => {
      this.setState(state, resolve);
    });
  }

  render() {
    let essentialSections = this.props.screenProps.essentialSections;

    let initialSlide = 0;
    let title = "";
    let currentChapterSections = [];
    let currentChapter = "";
    let currentChapterContentsLayout = [];

    try {
      let currentSection = essentialSections[this.state.currentIndex];
      currentChapter = currentSection.Chapter;
    } catch (error) {}

    for (let essentialSectionIndex = 0; essentialSectionIndex < essentialSections.length; essentialSectionIndex++) {
      let essentialSection = essentialSections[essentialSectionIndex];

      if (essentialSection.id === this.state.selectedID) {
        initialSlide = essentialSectionIndex;
      }

      if (essentialSection.Chapter === currentChapter) {
        currentChapterSections.push(essentialSection);
      }

      if (essentialSectionIndex === this.state.currentIndex) {
        if (essentialSection.Chapter.includes("Chapter")) {
          let essentialSectionsForChapter = essentialSections.filter(
            (anEssentialSection) => anEssentialSection.Chapter === essentialSection.Chapter
          );
          title = `Chp ${essentialSection.Chapter.split(":")[0].split(" ")[1]} - ${
            essentialSection.Section.split(" ")[0]
          } of ${essentialSectionsForChapter.length}`;
        } else {
          if (essentialSection.Section === "References 1") {
            title = "References - 1 of 2";
          } else if (essentialSection.Section === "References 2") {
            title = "References - 2 of 2";
          } else if (essentialSection.Chapter === "Contents") {
            title = "";
          } else {
            title = essentialSection.Section;
          }
        }
      }
    }

    if (this.props.screenProps.showTextToSpeech) {
      title = "";
    }

    const isBookmarked = this.isBookmarked();

    try {
      for (
        let currentChapterSectionIndex = 0;
        currentChapterSectionIndex < currentChapterSections.length;
        currentChapterSectionIndex++
      ) {
        let essentialSection = currentChapterSections[currentChapterSectionIndex];

        if (essentialSection.SubSection) {
          let subSections = essentialSection.SubSection.split(">,");

          for (let subSection of subSections) {
            var div = document.createElement("div");
            div.innerHTML = subSection;
            let subsectionID = div.children[0].id;
            var text = div.textContent || div.innerText || "";

            let subSectionClass = "H1";
            if (subSection.includes(`class="H2`)) {
              subSectionClass = "H2";
            }
            if (subSection.includes(`class="H3`)) {
              subSectionClass = "H3";
            }

            currentChapterContentsLayout.push(
              <div id={subsectionID} className={`subSectionRow ${subSectionClass}`}>
                {text}
              </div>
            );
          }

          let test = "";
        }
      }
    } catch (error) {}

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
              <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
            </IonButtons>
            <IonTitle>{title}</IonTitle>
            <IonButtons slot="end">
              {this.props.screenProps.showTextToSpeech ? (
                <>
                  <IonButton
                    className="headerButtons audioHeaderButtons"
                    onClick={(event) => this.readEssentialSection()}
                  >
                    <IonImg src={iconPlayWhite} />
                  </IonButton>
                  <IonButton className="headerButtons audioHeaderButtons" onClick={(event) => this.stopReading()}>
                    <IonImg src={iconStop} />
                  </IonButton>
                </>
              ) : null}
              <IonButton className="headerButtons" onClick={(event) => this.toggleFontModal(true, event)}>
                <IonImg src={iconAccessibility} />
              </IonButton>
              <IonButton className="headerButtons" onClick={() => this.bookmarkButtonPressed()}>
                <IonImg src={isBookmarked ? iconBookmarkActive : iconBookmarkInactive} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent
          color="#EDEEF0"
          id={`${this.props.match.params.tab}-guideline-content`}
          className="essentialsContent"
          // fullscreen
          ref={this.ionContent}
        >
          <div>
            <IonSlides
              id="essSlider"
              onIonSlideWillChange={() => this.scrollToTop()}
              onIonSlideDidChange={() => this.slideDidChange()}
              options={{ autoHeight: true, initialSlide: initialSlide }}
            >
              {essentialSections.map((essentialSection, i: number) => {
                if (i < this.state.currentIndex - 1 || i > this.state.currentIndex + 1) {
                  return <IonSlide key={i} />;
                }

                if (i === 0) {
                  return (
                    <IonSlide key={i}>
                      <div className="essentialsHeaderDiv">
                        <div className="globalContentMargin">
                          <span className="essentialsHeaderText">{"First Responder Care "}</span>
                          <span className="essentialsHeaderText essentialsHeaderTextGreen">{"Essentials"}</span>
                        </div>
                      </div>
                    </IonSlide>
                  );
                }

                var replacedHtml = essentialSection.HtmlData.replace(/src="image/g, 'class="img11" src="/assets/image');

                // change tables with multiple columns into cards
                if (
                  (essentialSection.Section === "3 Infection prevention and control" ||
                    essentialSection.Name === "Chapter 16: Trauma-6 Burns") &&
                  window.innerWidth < 830
                ) {
                  let divContainer = document.createElement("div");
                  divContainer.innerHTML = replacedHtml;

                  let tables = divContainer.getElementsByTagName("table");
                  let tablesLength = tables.length;

                  if (tables.length > 0) {
                    for (let tableIndex = 0; tableIndex < tablesLength; tableIndex++) {
                      let table = tables[tableIndex];

                      let tableObjects: any = [];
                      let tableHeaders = [];

                      for (let tableRowIndex = 0; tableRowIndex < table.rows.length; tableRowIndex++) {
                        let tableRow = table.rows[tableRowIndex];

                        if (tableObjects[tableRowIndex] == null) {
                          tableObjects[tableRowIndex] = {};
                        }

                        for (let tableCellIndex = 0; tableCellIndex < tableRow.cells.length; tableCellIndex++) {
                          let tableCell = tableRow.cells[tableCellIndex];

                          if (tableRowIndex === 0) {
                            tableHeaders.push(tableCell.innerText);
                          } else {
                            tableObjects[tableRowIndex][tableHeaders[tableCellIndex]] = tableCell.innerText;
                          }
                        }
                      }

                      let responsiveTablesForTableHtml = ``;

                      for (let tableObjectIndex = 0; tableObjectIndex < tableObjects.length; tableObjectIndex++) {
                        let tableObject = tableObjects[tableObjectIndex];

                        if (tableObjectIndex === 0) {
                          continue;
                        }

                        let responsiveTableHtml = `<table><tbody>`;

                        for (let tableHeaderIndex = 0; tableHeaderIndex < tableHeaders.length; tableHeaderIndex++) {
                          let tableHeader = tableHeaders[tableHeaderIndex];

                          let essentialsHorizontalTableFirstRowClass = "";
                          if (tableHeaderIndex === 0) {
                            essentialsHorizontalTableFirstRowClass = "essentialsHorizontalTableFirstRow";
                          }

                          responsiveTableHtml += "<tr>";
                          responsiveTableHtml += `<td class='essentialsHorizontalTableHeaders'><p class='tch ePub-B'>${tableHeader}</p></td><td class='${essentialsHorizontalTableFirstRowClass}'>${tableObject[tableHeader]}</td>`;
                          responsiveTableHtml += "</tr>";
                        }

                        responsiveTableHtml += `</tbody></table>`;

                        responsiveTablesForTableHtml += responsiveTableHtml;
                      }

                      table.outerHTML = "<div>" + responsiveTablesForTableHtml + "</div>";
                      let test = "";
                    }
                  }

                  replacedHtml = divContainer.innerHTML;
                }

                return (
                  <IonSlide key={i}>
                    <div id={"essentials-" + i} className="essentialSlide globalContentMargin">
                      <div className="essentialTopTitle">{essentialSection.Chapter}</div>
                      <hr className="essentialSlideHR" />
                      <div
                        style={{ fontSize: this.fontSize(17), lineHeight: this.props.screenProps.lineHeightChange }}
                        dangerouslySetInnerHTML={{ __html: replacedHtml }}
                      />
                    </div>
                  </IonSlide>
                );
              })}
            </IonSlides>

            <IonModal isOpen={this.state.contentsModalVisible}>
              <IonHeader>
                <IonToolbar mode="ios" color="#008477" className="navBar">
                  <IonTitle>{currentChapter}</IonTitle>
                  <IonButtons slot="end" className="phoneModalClose">
                    <IonButton className="headerButtons" onClick={this.closeContents.bind(this)}>
                      <img className="icon-44" src={buttonClose} />
                    </IonButton>
                  </IonButtons>
                </IonToolbar>
              </IonHeader>
              <IonContent>
                <div className="menu-sub">{currentChapterContentsLayout}</div>
              </IonContent>
            </IonModal>

            {window.innerWidth < 600 ? (
              <IonModal
                mode="ios"
                id="fontModal2"
                showBackdrop={true}
                isOpen={this.state.fontModalVisible}
                initialBreakpoint={1}
                breakpoints={[0, 1]}
                // event={this.state.fontModalEvent}
                backdropDismiss={true}
                onDidDismiss={() => this.toggleFontModal(false, null)}
              >
                <div className="triangle" />
                <FontPopover features={this.props.features} screenProps={this.props.screenProps} />
              </IonModal>
            ) : (
              <IonPopover
                mode="ios"
                id="fontModal"
                showBackdrop={false}
                isOpen={this.state.fontModalVisible}
                event={this.state.fontModalEvent}
                backdropDismiss={true}
                onDidDismiss={() => this.toggleFontModal(false, null)}
              >
                <div className="triangle" />
                <FontPopover features={this.props.features} screenProps={this.props.screenProps} />
              </IonPopover>
            )}

            <ImageViewerModal
              isOpen={this.state.imageModalVisible}
              isBookmarked={isBookmarked}
              isReferenceCard={false}
              imageSrc={this.state.imageSrc}
              toggleImageModal={this.toggleImageModal.bind(this)}
              bookmarkButtonPressed={this.bookmarkButtonPressed.bind(this)}
              tab={this.props.match.params.tab}
            />
          </div>
        </IonContent>
        <IonFooter>
          <div className="essentialsBottomBar">
            <div className="essentialsBottomBarButton" onClick={this.goToPreviousSlide.bind(this)}>
              <img alt="" src={disclosureLeft} className="icon-44" />
              Previous
            </div>
            {currentChapterContentsLayout.length > 0 ? (
              <div className="essentialsBottomBarButton" onClick={this.openContents.bind(this)}>
                Contents
              </div>
            ) : null}
            <div className="essentialsBottomBarButton" onClick={this.goToNextSlide.bind(this)}>
              Next
              <img alt="" src={disclosureRight} className="icon-44" />
            </div>
          </div>
        </IonFooter>
        <div className="appColorOverlay" />
      </IonPage>
    );
  }
}

export default withRouter(withIonLifeCycle(EssentialsPage));
